module.exports = __webpack_public_path__ + "img/alipay_qrcode.be981d61.png";